import { descriptionStyles as styles } from "@waytek/Overrides/Widgets/ProductDetails/ProductDetailsDescription";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

styles.wrapper = {
    css: css``,
};

styles.specificationsAccordionSection = {
    ...styles.specificationsAccordionSection,
    mergeCss: true,
    panelProps: {
        ...styles.specificationsAccordionSection?.panelProps,
        css: css`
            ${styles.specificationsAccordionSection?.panelProps?.css}
            p {
                ${mediaQueriesBP.maxMD} {
                    font-size: 16px;
                    line-height: 24px;
                }

                ${mediaQueriesBP.minMD} {
                    font-size: 16px;
                    line-height: 24px;
                }
            }
        `,
    },
};
